import React from 'react';
import { Link } from 'react-router-dom';
import { generateBillingUrl } from '../utils/urlHelpers';
import { HOSPITAL_BILLING_PATIENT } from '../routes/urls';

interface BillingLinkProps {
  uuidPatient: string;
  icon: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

const BillingLink: React.FC<BillingLinkProps> = ({ uuidPatient, icon, style, className }) => {
  const billingPatient = generateBillingUrl(uuidPatient);

  return (
    <Link to={billingPatient} style={{ textDecoration: 'none', color: 'inherit', ...style }} className={className}>
      {icon}
    </Link>
  );
};

export default BillingLink; 